

import React from 'react';
import Grid from '@mui/material/Grid';
import CloseIcon from "@mui/icons-material/Close";
import useMediaQuery from "@mui/material/useMediaQuery"; 

const GCTitleSticky = ({ title='', onClose=()=>{} }) => {
    const vMediaQuery = useMediaQuery("(max-width:650px)");   
  return (
    <Grid
      container
      spacing={0}
      columns={{ xs: 12, sm: 12, md: 12 }}
      className="GCSearchBtn-Tittle"
      sx={{ alignItems: "center", position: "sticky", top: 0, backgroundColor: "white", zIndex: 1 }}
    >
      <Grid
        item
        xs={11}
        sm={11}
        md={11.4}
        className="d-flex justify-content-center"
      >
        <div>{title}</div>
      </Grid>
      <Grid
        item
        xs={1}
        sm={1}
        md={0.5}
        className={vMediaQuery ?"d-flex justify-content-center" :"d-flex justify-content-end"}
      >
        <CloseIcon
          className="grnt-item-search-close-icon"
          onClick={onClose}
          style={{ fontSize: 'large!important', zIndex: 999 }}
          size="large" 
        />
      </Grid>
    </Grid>
    
  );
}

export default GCTitleSticky;
